// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__2b8vF","left":"title_left__17Ol9","text":"title_text__1pyYi","bule":"title_bule__3tvjn","orange":"title_orange__2TYCn"};